import { Contact, ContactGroup } from './contact';
import { FormGroup, FormControl, FormArray, Validators } from '@angular/forms';

export interface Business {
   id: number;

   name: string;
   address1: string;
   address2?: string;
   address3?: string;
   city: string;
   state?: string;
   postalcode: string;
   country: string ;

   phone?: string;
   fax?: string;
   email?: string;

   contacts?: Contact[];

   owned?: boolean;

   type?: string;
}


export class Business implements Business {
   constructor( b: any = {} ) {
      this.id = b?.id;

      this.name = b?.name || '';
      this.address1 = b?.address1 || '';

      if ( b?.address2 ) { this.address2 = b?.address2; }
      if ( b?.address3 ) { this.address3 = b?.address3; }

      this.city = b?.city || '';
      this.state = b.state || '';
      this.postalcode = b?.postalcode || '';
      this.country = b?.country || 'US';

      if ( b?.phone ) { this.phone = b.phone; }
      if ( b?.fax ) { this.fax = b.fax; }
      if ( b?.email ) { this.email = b.email; }

      this.contacts = [];
      if ( b?.contact && b?.contact?.name && b?.contact?.phone ) {
         this.contacts.push( new Contact( b['contact'] ));
      }

      if ( b?.contacts ) {
         b.contacts.map( c => this.contacts.push( new Contact( c ) ));
      }

      this.owned = b?.owned;

      this.type = b?.type || 'account';
   }

   public toString = (): string => {
      return [
         this.name,
         this.address1,
         this.address2,
         this.address3,
         this.city,
         this.state,
         this.postalcode,
         this.country,
         this.phone,
         this.fax,
         this.email,
         this.type,
         (this.contacts) ? this.contacts.map( c => c.toString()) : '',
      ].join('◬');
   }

   public save(): Business {
      return {
         id: this.id,
         name: this.name,
         address1: this.address1,
         address2: this.address2,
         address3: this.address3,
         city: this.city,
         state: this.state,
         postalcode: this.postalcode,
         country: this.country,
         phone: this.phone,
         fax: this.fax,
         contacts: this.contacts,
         type: this.type,
      } as Business;
   }
}

export function BusinessGroup( business: Business = new Business() ) {
   const fg = new FormGroup({
      id: new FormControl( business.id ),
      name: new FormControl( business.name ?? '', [ Validators.required, Validators.pattern(/^(?!\s*$).+/) ] ),
      address1: new FormControl( business.address1 ?? '', [ Validators.required, Validators.pattern(/^(?!\s*$).+/) ]),
      address2: new FormControl( business.address2 ?? '' ),
      address3: new FormControl( business.address3 ?? '' ),
      city: new FormControl( business.city ?? ''),
      state: new FormControl( business.state ?? '' ),
      postalcode: new FormControl( business.postalcode ?? '' ),
      country: new FormControl( business.country.slice( 0, 2 ), [ Validators.required ]),
      phone: new FormControl( business.phone ?? '' ),
      fax: new FormControl( business.fax ?? '' ),
      contacts: new FormArray([]),
      owned: new FormControl( business.owned ),
      type: new FormControl( business.type ?? 'account', [ Validators.required ] ),
   });

   if ( business.contacts ) {
      const contacts = fg.get('contacts') as FormArray;
      business.contacts.map( c => contacts.push( ContactGroup( c )));
   }

   return fg;
}
